import { Icon } from "../icon";

interface ForecastItemProps {
  item: types.Forecast;
}

const ForecastItem: React.FC<ForecastItemProps> = ({ item }) => (
  <div className="bg-black/35 backdrop-blur-3xl lg:p-4 rounded-3xl">
    {/* Weekday */}
    <div className="lg:text-4xl font-bold text-center text-white">
      {item.weekday}
    </div>

    {/* Day & Night */}
    <div className="flex justify-around">
      {/* Night */}
      <div className="relative flex items-start justify-center lg:text-6xl text-[#49A8FF] font-bold">
        <img
          className="absolute top-0 left-1/2 -translate-x-1/2 lg:w-[130px] lg:h-[100px]"
          src={`/images/pheno/${item.pheno_night_id}_night.svg`}
          alt={`Pheno ${item.pheno_night_id}_night`}
        />
        <div className="lg:pt-[85px] lg:w-[150px] text-end">
          {item.temp_night}°C
        </div>
      </div>

      {/* Day */}
      <div className="relative flex items-start justify-center lg:text-6xl text-white font-bold">
        <img
          className="absolute top-0 left-1/2 -translate-x-1/2 lg:w-[130px] lg:h-[100px]"
          src={`/images/pheno/${item.pheno_day_id}_night.svg`}
          alt={`Pheno ${item.pheno_day_id}_night`}
        />
        <div className="lg:pt-[85px] lg:w-[150px] text-end">
          {item.temp_day}°C
        </div>
      </div>
    </div>

    {/* Sunrise & Sunset */}
    <div className="border-t border-white lg:my-4"></div>
    <div className="flex justify-around">
      {/* Sunrise */}
      <div className="flex flex-col items-center">
        <span className="text-white text-center font-bold uppercase">
          мандах
        </span>
        <div className="text-4xl text-white flex items-center gap-2">
          <Icon name="sun-up.png" alt="sun-up" className="lg:h-[33px] lg:w-9" />
          <div>{item.sunrise}</div>
        </div>
      </div>

      {/* Sunset */}
      <div className="flex flex-col items-center">
        <span className="text-white text-center font-bold uppercase">
          жаргах
        </span>
        <div className="lg:text-4xl text-white flex items-center gap-2">
          <Icon
            name="sun-down.png"
            alt="sun-down"
            className="lg:h-[33px] lg:w-9"
          />
          <div>{item.sunset}</div>
        </div>
      </div>
    </div>

    <div className="border-t border-white lg:my-4"></div>

    {/* Date */}
    <div className="text-3xl text-white text-center">{item.date}</div>
  </div>
);

export default ForecastItem;
